import React from 'react';

import * as colors from '../../../../Util/Colors';
import { FormattedMessage } from 'react-intl';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

const CustomTooltip = ({
  active,
  payload,
  separator,
  formatter,
  itemStyle,
  user,
  type,
  isPercentage,
  isProfileTm,
  isTime,
}: any): React.ReactElement | null => {
  if (!active) {
    return null;
  }
  const listStyle = {
    padding: 8,
    margin: 0,
    backgroundColor: '#FFF',
    border: '1px solid #008080',
    borderRadius: 4,
    width: '180px',
    height: '104px',
  };

  const normalCircleStyle = {
    borderRadius: '50%',
    background: colors.normalFill,
    width: '12px',
    height: '12px',
  };

  const networkAvgCircleStyle = {
    borderRadius: '50%',
    background: colors.networkAvgFill,
    width: '12px',
    height: '12px',
  };

  const finalItemStyle = {
    display: 'block',
    paddingTop: 4,
    paddingBottom: 4,
    color: colors.textFill,
    ...itemStyle,
  };

  const date = payload.map((entry: any, i: number): React.ReactElement => {
    let { payload } = entry;

    return i % 2 === 0 ? (
      <li
        className='recharts-tooltip-item'
        // eslint-disable-next-line react/no-array-index-key
        key={`tooltip-item-${i}`}
        style={finalItemStyle}
      >
        <Text type='b200'>
          <span className='recharts-tooltip-item-name'>
            {payload.timestamp}
          </span>
        </Text>
      </li>
    ) : (
      <></>
    );
  });

  const items = payload
    .reverse()
    .map((entry: any, i: number): React.ReactElement | null => {
      if (entry.type === 'none' || entry.name === 'none') {
        return null;
      }

      const finalFormatter = entry.formatter || formatter;
      let { name, value, payload } = entry;
      if (finalFormatter) {
        const formatted = finalFormatter(value, name, entry, i, payload);
        if (Array.isArray(formatted)) {
          [value, name] = formatted;
        } else {
          value = formatted;
        }
      }
      if (Number.isNaN(value)) {
        return null;
      }
      return (
        <li
          className='recharts-tooltip-item'
          // eslint-disable-next-line react/no-array-index-key
          key={`tooltip-item-${i}`}
          style={finalItemStyle}
        >
          <Row>
            {type === name && (
              <>
                <div style={normalCircleStyle}></div>
                <Text type='b200'>
                  <span className='recharts-tooltip-item-name'>
                    {isProfileTm ? (
                      <FormattedMessage
                        id='cs_perfportal_my_team'
                        defaultMessage='My Team'
                      />
                    ) : (
                      `${user.displayName}`
                    )}
                  </span>

                  <span className='recharts-tooltip-item-separator'>
                    {separator}
                  </span>

                  <span className='recharts-tooltip-item-value'>
                    {isTime ? value.replace('.', ':') : value}
                  </span>
                  {isPercentage && (
                    <span className='recharts-tooltip-item-unit'>%</span>
                  )}
                </Text>
              </>
            )}
            {type !== name && (
              <>
                <div style={networkAvgCircleStyle}></div>
                <Text type='b200'>
                  <span className='recharts-tooltip-item-name'>
                    <FormattedMessage
                      id='cs_perfportal_network_benchmark'
                      defaultMessage='Network Benchmark'
                    />
                  </span>
                  <span className='recharts-tooltip-item-separator'>
                    {separator}
                  </span>

                  <span className='recharts-tooltip-item-value'>
                    {isTime ? value.replace('.', ':') : value}
                  </span>
                  {isPercentage && (
                    <span className='recharts-tooltip-item-unit'>%</span>
                  )}
                </Text>
              </>
            )}
          </Row>
        </li>
      );
    })
    .filter((entry: React.ReactElement | null) => entry !== null);

  if (items.length === 0) {
    return null;
  }

  return (
    <ul className='recharts-tooltip-item-list' style={listStyle}>
      {date}
      {items}
    </ul>
  );
};

export default CustomTooltip;
